import ServiceBase from '@/Services/ServiceBase';

export default class BusinessService extends ServiceBase {
    getAssetGroups(businessId, tag) {
        return this.request('get', `/business/${businessId}/assetGroups`, { tag });
    }
    createCampaign(
        businessId,
        {
            name,
            startsAt,
            endsAt,
            tag,
            maxDailySpend,
            maxSpend,
            audienceSettings = {
                locationRestrictedType: 'Unlimited',
                restrictedLocationIsoCodes: [],
            },
            optimizationTarget = 'Purchase',
            targetUrl,
            customConversionUrlPart,
            spendingStrategy,
            marketingEventStartsAt,
            marketingEventEndsAt,
            useUnusedFunds,
            beneficiaryName,
            payerName,
            contentAnalysisUrl,
            adDeliveryBrandPreference,
            webhookNotificationUrl,
            webhookNotificationApiKey,
            currencyShortName,
        },
    ) {
        return this.request('post', `/business/${businessId}/campaign`, {
            name,
            startsAt,
            endsAt,
            tag,
            maxDailySpend,
            maxSpend,
            audienceSettings,
            optimizationTarget,
            targetUrl,
            customConversionUrlPart,
            spendingStrategy,
            marketingEventStartsAt,
            marketingEventEndsAt,
            useUnusedFunds,
            beneficiaryName,
            payerName,
            contentAnalysisUrl,
            adDeliveryBrandPreference,
            webhookNotificationUrl,
            webhookNotificationApiKey,
            currencyShortName,
        });
    }

    searchCampaigns(businessId, {
        pageNumber,
        pageSize = 10,
        searchTerm,
        sortDirection,
        sortBy,
        tag,
        statuses = [],
        isActivated,
        isWithinSchedule,
    }) {
        return this.request('post', `/business/${businessId}/campaign/search`, {
            pageNumber,
            pageSize,
            searchTerm,
            sortDirection,
            sortBy,
            tag,
            statuses,
            isActivated,
            isWithinSchedule,
        });
    }

    getIssues(businessId, tag) {
        return this.request('get', `/business/${businessId}/tag/${tag}/issues`, null);
    }

    getBusinessSummary(businessId, tag) {
        return this.request('get', `/business/${businessId}/summary`, { tag });
    }

    updateBusiness(businessId, invoiceData) {
        return this.request('put', `/business/${businessId}`, invoiceData);
    }

    getBusiness(businessId) {
        return this.request('get', `/business/${businessId}`, null);
    }

    getWallets(businessId) {
        return this.request('get', `/business/${businessId}/wallets`, null);
    }
}
